function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e84326;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.033 0.001)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M12.212,7.465,7.451,2.7a.721.721,0,0,0-1.02,1.02L10.009,7.3H.689a.722.722,0,1,0,0,1.443h9.32l-3.53,3.53a.721.721,0,1,0,1.02,1.02L12.26,8.533a.688.688,0,0,0,.048-.053.288.288,0,0,0,.019-.026c.008-.01.016-.02.023-.031l.019-.031c.006-.01.012-.019.017-.029s.011-.022.016-.033.01-.021.015-.031.008-.022.012-.032.009-.023.012-.034l.008-.033c0-.012.007-.024.008-.036s0-.025.006-.038,0-.021,0-.031a.731.731,0,0,0,0-.142c0-.011,0-.021,0-.031s0-.026-.006-.038-.006-.024-.008-.036l-.008-.033c0-.012-.008-.022-.012-.034a.285.285,0,0,0-.012-.032c0-.011-.01-.021-.015-.031s-.01-.022-.016-.033l-.017-.029-.019-.031c-.007-.011-.015-.021-.023-.031s-.012-.017-.019-.026a.7.7,0,0,0-.074-.076l-.022-.026M15.958,16V0H7.342V1.23h7.385V14.768H7.342V16h8.615Z",
  transform: "translate(0)"
}));

var SvgLeaveGroup = function SvgLeaveGroup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.991,
    height: 16,
    viewBox: "0 0 15.991 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeaveGroup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/leave-group.a3e3a0d2.svg";
export { ForwardRef as ReactComponent };